import { Box, CircularProgress } from "@mui/material";
import { colorVariables } from "../../utils/colorVariable";

export const Loading = () => {
  return (
    <Box
      display={"flex"}
      alignItems={"center"}
      justifyContent={"center"}
      sx={{
        position: "absolute",
        left: "50%",
        top: "40%",
      }}
    >
      <CircularProgress
        variant="indeterminate"
        sx={{ color: colorVariables.primary }}
      />
    </Box>
  );
};
